import {useEffect} from 'react';

export const useDebounce = (fn: () => void, debounce: number, deps: any[]) => {
  useEffect(() => {
    const debouncedFunction = setTimeout(fn, debounce);
    return () => clearTimeout(debouncedFunction);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debounce, fn, ...deps]);
};
